exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notFound[data-v-73410565]{display:flex;flex-direction:column;align-items:center;background-color:#2b2b2b;margin:10px 0;border-radius:5px;padding:30px 0}.notFound>h2[data-v-73410565]{font-weight:bolder;margin:0}.notFound>h3[data-v-73410565]{font-weight:lighter;font-style:italic;margin-top:10px}.notFound .imgContainer[data-v-73410565]{margin-top:10px}.notFound .caption[data-v-73410565]{margin-top:-10px;font-size:16px}.notFound .home[data-v-73410565]{display:block;margin-top:40px;margin-bottom:10px;font-size:24px;color:#ddd;text-decoration:none;padding:10px 20px;background-color:#444;border-radius:10px;border:1px solid transparent}.notFound .home[data-v-73410565]:hover{background-color:#555;border:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73410565","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotFound.vue
// module id = 169
// module chunks = 0